import { BiPrinter } from "react-icons/bi";
import React, { useRef } from 'react';
import CxDate from '../../cx/CxDate';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxChooser from '../../cx/CxChooser';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import GxForm from '../../gx/GxForm';
import GxPrintLong from '../../gx/GxPrintLong';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import CxSnackbar from '../../cx/CxSnackbar';
import CxStatic from '../../cx/CxStatic';
import { StoreClient, StoreImage, isApp } from "../../gx/GxStore";
import { useAccess } from '../../hx/useAccess';
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxImageEditor from '../../cx/CxImageEditor';
import * as FxStr from '../../fx/FxStr';
import CxDlgAlert from '../../cx/CxDlgAlert';
import MxTypeOTF from '../common/otf/MxTypeOTF';

const MxClientImageForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.images'));

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeImage, ] = useSessionStorage('StoreImage', StoreImage);

  const r_form = React.useRef(null);
  const r_dlg_alert = React.useRef(null);
  const r_dlg_new_txTypeImage = React.useRef(null);
  
  const rf_date = React.useRef(null);
  const rf_txTypeImage = React.useRef(null);
  const rf_image = React.useRef(null);

  const r_snack_ask_save = React.useRef(null);

  let r_gx_print_long = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const formLoad = async (data) => {
    if (data === null) { //nuevo registro
      rf_date.current.setValToday();
      rf_txTypeImage.current.setKeyAndVal("t_image", "txTypeImage", "itImage", "000001.SRV");
    }
  }
  const formSave = async (lastSaveRv) => {
    // se guardó exitosamente
    storeClient.inImage = lastSaveRv.theValue;
    Promise.all([setStoreClient(storeClient)]).then((result) => {
      rf_image.current.doSave(lastSaveRv.theValue);
      r_dlg_alert.current.setOpen(false);
      forceUIUpdate();
    });
  }
  const formDelete = async (rv) => {
  }

  const doPrintX = async (option) => {
    let filter = {};
    filter['inImage'] = storeClient.inImage;
    let record = {};
    r_gx_print_long.current.setUrlBuild('images/report/grl_build');
    r_gx_print_long.current.setUrlGet('images/report/grl_get');
    //----------------
    Promise.all([
      r_gx_print_long.current.setFilter(filter),
      r_gx_print_long.current.setRecord(record),
    ]).then((result) => {
      r_gx_print_long.current.doPrint();
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.image')}`}
        xref={r_form}
        url="images"
        filterIdField='inImage'
        filterIdValue={storeClient.inImage}
        onFormDelete={isFullAccess() && formDelete}
        onFormLoad={formLoad}
        onFormBeforeSave={() => {
          r_dlg_alert.current.setText(trans('msg.saving'));
          r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
          r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
          r_dlg_alert.current.setHasButtonClose(false);
          r_dlg_alert.current.setOpen(true);
          return true;
        }}
        onFormSave={isFullAccess() && formSave}
        disableSnackSave={true}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<BiPrinter fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={() => doPrintX()} tooltip={trans('field.print')} />
          </div>
        }
      >
        <CxHidden xref={useRef(null)} dbfield="n_image.inClient" value={storeClient.inClient || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_image.inAnimal" value={storeClient.inAnimal || ''} />

        <CxHidden xref={useRef(null)} dbfield="n_image.txLinkImageTable" value={storeImage.txLinkImageTable || ''} />
        <CxHidden xref={useRef(null)} dbfield="n_image.txLinkImageId" value={storeImage.txLinkImageId || ''} />

        {(isApp('invo') || isApp('opti')) && <CxStatic label={`${storeClient.txClient}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />}
        {(isApp('vett') || isApp('spaw')) && <CxStatic label={`${FxStr.join(' / ', storeClient.txClient, storeClient.txAnimal)}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />}

        <CxDate xref={rf_date} label={trans('field.date')} dbfield={`n_image.dtFrom`} required />
        
        <CxChooser xref={rf_txTypeImage}
          label={trans('field.type')}
          dbfield="t_image.txTypeImage" dbfieldkey="n_image.itImage"
          table="t_image"
          col_id="itImage"
          col_tx="txTypeImage"
          onButtonAdd={() => {
            rf_txTypeImage.current.setDlg(false);
            r_dlg_new_txTypeImage.current.setDlg(true);
          }}
          required
        />
        <MxTypeOTF xref={r_dlg_new_txTypeImage}
          url="images/type/otf"
          name='field.type'
          parent={rf_txTypeImage}
          onOk={(itXXX, txTypeXXX) => {
            rf_txTypeImage.current.setKey(itXXX);
            rf_txTypeImage.current.setVal(txTypeXXX);
          }}
        />

        <CxInput xref={useRef(null)} label={trans('field.remarks')} dbfield="n_image.txRemarks" minRows={4} speech />

        <CxImageEditor xref={rf_image} 
          url='images' 
          inXXX={storeClient.inImage} 
          can_search 
          pen_red_default 
          pen_red 
          pen_blue 
          pen_yellow 
        />

      </GxForm>

      <CxDlgAlert xref={r_dlg_alert} />
      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <GxPrintLong xref={r_gx_print_long} />

    </div>
  );

}

export default MxClientImageForm;
